import { createAction } from 'redux-actions';
import { actionTypePrefix } from './constants';
export var likeComment = createAction(actionTypePrefix + "/LIKE", function (comment) { return ({
    comment: comment,
}); });
export var unlikeComment = createAction(actionTypePrefix + "/UNLIKE", function (comment) { return ({
    comment: comment,
}); });
export var reportComment = createAction(actionTypePrefix + "/REPORT", function (comment) { return ({
    comment: comment,
}); });
export var featureComment = createAction(actionTypePrefix + "/FEATURE", function (comment) { return ({
    comment: comment,
}); });
export var unfeatureComment = createAction(actionTypePrefix + "/UNFEATURE", function (comment) { return ({
    comment: comment,
}); });
export var hideComment = createAction(actionTypePrefix + "/HIDE", function (comment, insideModal) { return ({
    comment: comment,
    insideModal: insideModal,
}); });
export var unhideComment = createAction(actionTypePrefix + "/UNHIDE", function (comment) { return ({
    comment: comment,
}); });
export var requestSuccess = createAction(actionTypePrefix + "/SUCCESS", function (actionType, comment) { return ({
    isBusy: false,
    comment: comment,
    actionType: actionType,
}); });
export var requestFailure = createAction(actionTypePrefix + "/FAILURE", function (actionType, comment, error) { return ({
    comment: comment,
    error: error,
    actionType: actionType,
}); });
//# sourceMappingURL=actionCreators.js.map